import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string>(
  ({ colors }: ITheme) => ({
    root: {
      cursor: 'pointer',
      position: 'relative',
      display: 'inline-block',

      '&.disabled': {
        opacity: '.5',
      },
    },
    control: {
      opacity: 0,
      position: 'absolute',
      left: '0',
      top: '0',
      width: '24px',
      height: '24px',
    },
    label: {
      fontWeight: FontWeight.Medium,
      fontSize: '14px',
      color: colors.body,
      display: 'inline-block',
      verticalAlign: 'middle',

      userSelect: 'none',
    },
    checkboxContainer: {
      width: 'auto !important',
      height: 'auto !important',
    },
    icon: {
      width: '24px',
      height: '24px',
      display: 'inline-block',
      verticalAlign: 'middle',
      marginInlineEnd: '8px',
      cursor: 'pointer',
    },
  }),
  {
    name: 'checkbox',
  },
);

export default useStyles;
